/**
 * @desc: 风控审计
 * @created: 2020/5/9
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'
import qs from 'qs'

// 获取列表查询数据
export const getListData = params => {
  return request.get('/riskAudit/list', params)
}

// 获取总览分析上方数据 card-item
export const getAnalyzeData = params => {
  return request.get('/riskAudit/analyze/data', params)
}

// 总览分析 风控数据 图表数据(小时)
export const getAnalyzeRiskHours = params => {
  return request.get('/riskAudit/analyze/risk/data', params)
}

// 总览分析 风控数据 图表数据联合运算
export const getAnalyzeRiskJoint = params => {
  return request.get('/riskAudit/analyze/total/risk/data', params)
}

// 总栏分析 渠道风控统计表
export const getAnalyzeBankData = params => {
  return request.get('/riskAudit/analyze/bank', params)
}

// 总栏分析 收单机构风控统计表
export const getAnalyzeCompanys = params => {
  return request.get('/riskAudit/analyze/company', params)
}

// 获取渠道划分联合运算图表数据
export const getChannelBankJoint = params => {
  return request.get('/riskAudit/bank/listRiskNumByBank', params)
}

// 获取渠道划分列表数据
export const getChannelBankList = params => {
  return request.get('/riskAudit/bank/list', params)
}

// 获取收单机构划分 列表数据
export const getCompanysList = params => {
  return request.get('/riskAudit/company/list', params)
}

// 获取收单机构划分 线形图图表数据
// params: { checkDayMin, checkDayMax, companyId, type }
export const getCompanyRiskLine = params => {
  return request.get('/riskAudit/company/total/riskNum', params)
}

// 获取收单机构划分 饼图
// params: { tradeDay, tradeDayEndTime, companyId }
export const getCompanyRiskPie = params => {
  return request.get('/riskAudit/company/riskType', params)
}

// 关系验证-相关联系人列表
export const listContacts = data => {
  return request.get('/acceptanceReview/listContacts', qs.stringify(data))
}

// 关系验证-相关法人列表
export const listRelationCorps = data => {
  return request.get('/acceptanceReview/listRelationCorps', qs.stringify(data))
}

// 关系验证-相关地理信息列表
export const listRelationGeographicInfo = data => {
  return request.get('/acceptanceReview/listRelationGeographicInfo', qs.stringify(data))
}

// 关系验证-用户匹配信息列表
export const listUserMatchingInfor = data => {
  return request.get('/acceptanceReview/selectNearMerAndSup', qs.stringify(data))
}
